import React from 'react'
import { Link } from 'react-router-dom'

import { isEmpty } from 'lodash'
import { Icon } from '@components/shared/elements'

export const EmailButton = ({ onClick }) => (
  <div className='floatingContacts'>
    <button className='button large text emailButton' onClick={onClick} data-ga-action>
      <div><Icon icon='envelope' size='lg' className='mr1' /> Contato</div>
    </button>
  </div>
)

export const CallButton = ({ onClick, label }) => (
  <div className='floatingContacts'>
    <button className={'button info large text simButton'} onClick={onClick} data-ga-action>
      <div><Icon icon='phone' size='lg' className='mr1' /> {label}</div>
    </button>
  </div>
)

export const SimulatorButton = React.memo(({ buttonLink }) => (
  <div className='floatingContacts'>
    <Link className='button info large text simButton' to={buttonLink} data-ga-action='true'>
      Faça uma simulação
    </Link>
  </div>
))

export const SimulatorButtonSP = React.memo(({ buttonLink }) => (
  <div className='floatingContacts'>
    <Link
      className='button info large text simButton simButton--sp'
      to={buttonLink} data-ga-action='true'>
      <div>
        <Icon icon='calculator' size='lg' className='mr1' /> Simule Aqui
        </div>
    </Link>
  </div>
))

export const WhatsAppModalSP = ({ onClick }) => {
  return (
    <button onClick={onClick} className='button info large text simWhats' data-ga-action>
      <Icon iconType='fab' icon='whatsapp' className='mr1' /> Whatsapp
    </button>
  )
}

export const WhatsAppButtonSP = ({ onClick }) => (
  <button
    onClick={onClick}
    className='button info large text simWhats'
    data-ga-action>
    <Icon iconType='fab' icon='whatsapp' className='mr1' /> Whatsapp
  </button>
)

export const WhatsAppButtons = ({
  onClickModal,
  onClickLink,
  phone,
}) => (
    <div className='floatingContacts'>
      {!isEmpty(phone) && phone.TelefoneVendaContatoWhatsApp !== null ? (
        <WhatsAppButtonSP
          onClick={onClickLink}
        />
      ) : (
          <WhatsAppModalSP onClick={onClickModal} />
        )}
    </div>
  )



// WEBPACK FOOTER //
// ./src/components/shared/elements/ContactBubbles/ContactBubbleButtons.js